export default function Masthead() {
  return (
    <header className="masthead">
      <div className="shell">
        <div className="mark">
          <svg className="mark__glyph" viewBox="0 0 44 32" aria-hidden="true" focusable="false">
            <path d="M4 3h11v13c0 5-3.6 9.2-5.5 11C7.6 25.2 4 21 4 16Z" />
            <path d="M16.5 3h11v13c0 5-3.6 9.2-5.5 11-1.9-1.8-5.5-6-5.5-11Z" />
            <path d="M29 3h11v13c0 5-3.6 9.2-5.5 11C32.6 25.2 29 21 29 16Z" />
          </svg>
          <span className="mark__word">The Wall</span>
        </div>
        <p className="masthead__line">
          A public board, open to anyone. <strong>ShieldWall</strong> keeps the bots off it.
        </p>
      </div>
    </header>
  );
}
